export default "__VITE_ASSET__Dc_TEEvZ__"